import axios from "axios";
export const HTTP = axios.create({
  baseURL:
    window.location.origin === "https://notify-push.cc"
      ? "https://api.notify-push.cc/api/"
      : "https://stage-api.notify-push.cc/api/",
  headers: {
    Authorization: localStorage["token"],
  },
});
